var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M25.7868 19.32L24.4534 17.1066C24.1734 16.6133 23.9201 15.68 23.9201 15.1333V11.76C23.9201 7.4133 20.3868 3.86664 16.0268 3.86664C11.6668 3.86664 8.13342 7.4133 8.13342 11.76V15.1333C8.13342 15.68 7.88009 16.6133 7.60009 17.0933L6.25342 19.32C5.72009 20.2133 5.60009 21.2 5.93342 22.1066C6.25342 23 7.01342 23.6933 8.00009 24.0266C10.5868 24.9066 13.3068 25.3333 16.0268 25.3333C18.7468 25.3333 21.4668 24.9066 24.0534 24.04C24.9868 23.7333 25.7068 23.0266 26.0534 22.1066C26.4001 21.1866 26.3068 20.1733 25.7868 19.32Z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4.42669C18.08 4.06669 17.08 3.86669 16.0267 3.86669C14.9867 3.86669 13.9867 4.05335 13.0667 4.42669C13.64 3.34669 14.7733 2.66669 16.0267 2.66669C17.2933 2.66669 18.4133 3.34669 19 4.42669Z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7733 26.68C19.2133 28.2267 17.7333 29.3334 16 29.3334C14.9467 29.3334 13.9067 28.9067 13.1733 28.1467C12.7467 27.7467 12.4267 27.2134 12.24 26.6667C12.4133 26.6934 12.5867 26.7067 12.7733 26.7334C13.08 26.7734 13.4 26.8134 13.72 26.84C14.48 26.9067 15.2533 26.9467 16.0267 26.9467C16.7867 26.9467 17.5467 26.9067 18.2933 26.84C18.5733 26.8134 18.8533 26.8 19.12 26.76C19.3333 26.7334 19.5467 26.7067 19.7733 26.68Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellWhite);
export default __webpack_public_path__ + "static/media/bell-white.34739c3937dbb81cd17a5efc37d6777f.svg";
export { ForwardRef as ReactComponent };